import { takeLatest, put, call } from 'redux-saga/effects';
import { purchaseNFTsActions } from './slice';
import { purchaseNFT } from './functions';

function* purchaseNFTReference({ payload }) {
  try {
    const response = yield call(purchaseNFT, payload);
    yield put(purchaseNFTsActions.purchaseNFTSuccess(response));
  } catch (error) {
    yield put(purchaseNFTsActions.purchaseNFTError(error));
  }
}

function* PurchaseNFTsSaga() {
  yield takeLatest(purchaseNFTsActions.purchaseNFT.type, purchaseNFTReference);
}
//
export default PurchaseNFTsSaga;
